// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"Loader_pageLoader__1OvbO","load3":"Loader_load3__Q1xjv","pageWrapper":"Loader_pageWrapper__OWw0h"};